import { trace } from "@opentelemetry/api";
import { wrapTracer } from "@opentelemetry/api/experimental";

export const tracers = {
    get default() {
        return getTracer("@octopusdeploy/default");
    },
    get reactClient() {
        return getTracer("@octopusdeploy/octopus-react-client");
    },
    get ai() {
        return getTracer("Octopus.AI");
    },
} as const;

function getTracer(tracerName: string) {
    return wrapTracer(trace.getTracer(tracerName));
}
